import { createAsyncThunk } from "@reduxjs/toolkit";
import { submitCardInteraction } from "./cardInteractionAPI";

export const submitCardInteractionAsync = createAsyncThunk(
    "submitCardInteraction",
    async ({ gameType, type_of_card, player, skipped, stopped_by, shot_player }, { getState, rejectWithValue }) => {
        try {
            const response = await submitCardInteraction({ gameType, type_of_card, player, skipped, stopped_by, shot_player }, getState);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Unknown error' });
        }
    }
);
